import { createAction, props } from "@ngrx/store";
import { Help } from "src/app/models/help.models";

export const getHelp = createAction('[Help] Get Help');

export const getHelpSuccess = createAction('[Help] Get Help Success', props<{ help: Help[] }>());

export const getHelpFailure = createAction('[Help] Get Help Failiure', props<{ error: any }>());
